import { AfterViewInit, ChangeDetectorRef, Component, inject, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CerFormComponent, ICerFormOwner } from '@form/cer-form.component';
import { CerFormPaneComponent } from '@form/cer-form-panes/cer-form-pane/cer-form-pane.component';
import { CerFormDataNavigation } from '../cer-form-navigation.service';

@Component({
  selector: 'cer-form-panes',
  templateUrl: './cer-form-panes.component.html',
  styleUrls: ['./cer-form-panes.component.css']
})

export class CerFormPanesComponent implements ICerFormOwner, AfterViewInit {

  private activatedRoute = inject(ActivatedRoute);

  private cd: ChangeDetectorRef = inject(ChangeDetectorRef);
  public ngAfterViewInit(): void {
    this.cd.detectChanges();

    this.form?.initContext(this.paneComponents);
  }

  @Input() dataNavigation: CerFormDataNavigation;

  public form: CerFormComponent;
  @ViewChild('form', { static: false }) set formContent(form: CerFormComponent) {
    if (form && form != this.form) {
      this.form = form;
      this.form.owner = this;
      this.form.initContext(this.paneComponents);
      const formContextService = this.form.formContextService;
      formContextService.form = form;
      if (this.dataNavigation != null) {
        formContextService.navigationShow(this.dataNavigation);
      }
      else {
        formContextService.activatedRouteShow(this.activatedRoute);
      }
    }
  }

  protected recreateCount: number = null;
  public formRecreate() {
    this.recreateCount = (this.recreateCount ?? 0) + 1;  // pickup by directict on CerForm
  }

  private paneComponents: QueryList<CerFormPaneComponent>
  @ViewChildren(CerFormPaneComponent) set setPaneComponents(paneComponents: QueryList<CerFormPaneComponent>) {
    this.paneComponents = paneComponents;
    this.initContext(paneComponents);
  }

  private initContext(paneComponents: QueryList<CerFormPaneComponent>) {
    if (paneComponents?.length > 0 && this.form != null) {
      this.form.initContext(paneComponents);
    }
  }
}
